module.exports = remove => {
    remove('alarm');
    remove('ok');
}


// WEBPACK FOOTER //
// ./js/viscom/kaspersky/risksOverview/utils/clearRiskValueClass.js